// import { createRouter, createWebHistory } from "vue-router";
import { createRouter, createWebHashHistory } from "vue-router";
const routes = [
  {
    path: "/",
    name: "Wellcome",
    component: () => import("@/views/welcome/index.vue"),
  },
  {
    path: "/Home",
    name: "Home",
    component: () => import("@/views/home/index.vue"),
  },
  {
    path: "/Task",
    name: "Task",
    component: () => import("@/views/task/index.vue"),
  },
  {
    path: "/wordPage",
    name: "wordPage",
    component: () => import("@/views/word/index.vue"),
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  if (from.name === 'Task' && to.name === 'Home') {
    console.log('从Task返回Home，可以在这里处理刷新逻辑')
    router.go(0)
  }
  next() // 确保调用 next()
})
export default router;
